import request from './financeRequest'

export const commissionApi = {
  listPlans: () => request.get('/finance/commission-plans'),
  createPlan: (data) => request.post('/finance/commission-plans', data),
  activatePlan: (id) =>
    request.post(`/finance/commission-plans/${id}/activate`),
  branchRules: (planId) =>
    request.get(`/finance/commission-plans/${planId}/branch-rules`),
  saveBranchRule: (planId, data) =>
    request.post(`/finance/commission-plans/${planId}/branch-rules`, data),
  teamRules: (planId) =>
    request.get(`/finance/commission-plans/${planId}/team-rules`),
  saveTeamRule: (planId, data) =>
    request.post(`/finance/commission-plans/${planId}/team-rules`, data),
  adjustments: () => request.get('/finance/commission-adjustments'),
  createAdjustment: (data) =>
    request.post('/finance/commission-adjustments', data),
  confirmAdjustment: (id) =>
    request.post(`/finance/commission-adjustments/${id}/confirm`),
  voidAdjustment: (id, reason) =>
    request.post(`/finance/commission-adjustments/${id}/void`, { reason }),
}
